/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Input, InputProps } from '@chakra-ui/react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    InputProps {}

export default function Component<T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    ...rest
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => {
        if ((value as any) instanceof Date) value = value.toISOString()

        return (
          <Input
            onChange={onChange}
            value={String(value).replace(/T.*/, '') || ''}
            type="date"
            {...rest}
          />
        )
      }}
    />
  )
}
